module.exports = __webpack_public_path__ + "static/eshop-light-de9182c6966784c370694ec249690d95.png";